// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import ReactHowler from "react-howler";
import * as Retry$LiteracyplanetClientFlags from "./Retry.res.mjs";

function MemoPlay$Memo(props) {
  var onLoadError = props.onLoadError;
  var onEnd = props.onEnd;
  var playing = props.playing;
  var src = props.src;
  var onPlay = props.onPlay;
  var onLoad = props.onLoad;
  return React.useMemo((function (param) {
                return React.createElement(ReactHowler, {
                            src: src,
                            playing: playing,
                            onEnd: onEnd,
                            onLoadError: onLoadError,
                            onLoad: onLoad,
                            onPlay: onPlay
                          });
              }), [
              src,
              playing
            ]);
}

var Memo = {
  make: MemoPlay$Memo
};

function MemoPlay(props) {
  var __playing = props.playing;
  var onPlaying = props.onPlaying;
  var onLoaded = props.onLoaded;
  var playing = __playing !== undefined ? __playing : true;
  var match = Retry$LiteracyplanetClientFlags.use();
  var onLoad = onLoaded !== undefined ? onLoaded : (function (param) {
        
      });
  var onPlay = onPlaying !== undefined ? onPlaying : (function (param) {
        
      });
  if (match[0]) {
    return React.createElement(MemoPlay$Memo, {
                onLoad: onLoad,
                onPlay: onPlay,
                src: props.src,
                playing: playing,
                onEnd: props.onEnd,
                onLoadError: match[1]
              });
  } else {
    return null;
  }
}

var make = MemoPlay;

export {
  Memo ,
  make ,
}
/* react Not a pure module */
